// extracted by mini-css-extract-plugin
module.exports = {"review":"ClientReviewCard_review__qE1_j","message":"ClientReviewCard_message__TbIOs","time":"ClientReviewCard_time__18bXu","rating-row":"ClientReviewCard_rating-row__p4RYL"};